import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useContext, useEffect } from "react";
import { Dot_Lottie } from "../common/lotties/dot-lottie/Dot_Lottie";
import { PowerProgress } from "../../utils/apis/homepage";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";
import { useLocation, Link } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const { IMG_URL } = useContext(Context);

  const [appsetup, setAppSetup] = useState({});
  const location = useLocation();

  const getAppSetup = async () => {
    const res = await PowerProgress();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  return (
    <section className="header_section">
      <div className="top-bar">
        <div className="top-bar-inner container">
          <div className="logo-wrapper" onClick={() => navigate("/")}>
            <img
              src={IDS?.IMG_URL + appsetup?.logo}
              alt="My Flower Event"
              className="top-logo"
            />
          </div>
          <div className="top-contact">
            <div className="contact-btn">
              {/* <div className="button_holder">
                <button
                  className="subsidy-btn-mobile"
                  onClick={() => navigate("/subsidy-policy")}
                >
                  <Dot_Lottie /> Subsidy & Policies
                </button>
              </div> */}
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <div className="label">
                {/* <p>Contact Number:</p> */}
                <div><p className="value">{appsetup.contactno}</p></div>
                <div><p className="value">{appsetup.alt_contact_no}</p></div>
              </div>
            </div>
            <div className="divider" />
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <div className="label">
                {/* <p>Email:</p> */}
                <p className="email">{appsetup.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="middle-text">
        <p className="event-name">MY FLOWER MEMORIES</p>
      </div>

      <div className="abs_div">
        <div className="container p-0">
          <Navbar
            expand="lg"
            className="main-navbar"
            collapseOnSelect
            expanded={expanded}
            onToggle={(isOpen) => setExpanded(isOpen)}
          >
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={() => setExpanded(!expanded)}
              className=""
            />

            <Navbar.Collapse
              id="main-navbar-nav"
              className={
                expanded ? "collapse show smooth-collapse" : "collapse"
              }
            >
              <Nav className="main-nav-links">
                <Nav.Link
                  as={NavLink}
                  to="/"
                  onClick={() => setExpanded(false)}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                >
                  About us
                </Nav.Link>
                {/* <Nav.Link
                  as={NavLink}
                  to="/services"
                  onClick={() => setExpanded(false)}
                >
                  Service
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/gallery"
                  onClick={() => setExpanded(false)}
                  className={`nav-link ${
                    location.pathname.startsWith("/gallery") ? "active" : ""
                  }`}
                >
                  Gallery
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/blog"
                  onClick={() => setExpanded(false)}
                >
                  Blog
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                >
                  Contact Us
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/faq"
                  onClick={() => setExpanded(false)}
                >
                  FAQ
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>

            {/* <div className=" nav-actions ">
              <button
                className="subsidy-btn"
                onClick={() => navigate("/subsidy-policy")}
              >
                <Dot_Lottie /> Subsidy & Policies
              </button>
            </div> */}
          </Navbar>
        </div>
      </div>
    </section>
  );
};

export default Header;
